import { useLocation } from "react-router-dom";
import OmopTable from "../../common/OmopTable";

export default function DataTable() {
  const path = useLocation().pathname.split("/").pop();
  return <OmopTable tableName={path} />;
}
